/**
 * Échelle du pipeline bitmap (assets WebP à GSD fixe).
 *
 * Doit rester aligné avec scripts/bitmap_pipeline_config.json :
 *   fixed_mm_per_px, reference_scale_px_per_mm (= 1 / fixed_mm_per_px).
 */
/** Moitié de 0,541926 : les exports actuels ont ~2× plus de px/mm que ce nominal (mesures sinon doublées). */
export const FIXED_MM_PER_PX = 0.270963;

/** px/mm : une unité de longueur « monde » sur le canvas */
export const REFERENCE_SCALE_PX_PER_MM = 1 / FIXED_MM_PER_PX;

/** Sur-échantillonnage export PNG (1 = taille nominale ; 2–3 = plus net, surtout avec rotations). */
export const EXPORT_RASTER_MULTIPLIER = 2;

/** Côté max du PNG exporté (px), après multiplicateur. */
export const EXPORT_MAX_SIDE = 8192;
